export default __webpack_public_path__ + "images/SU.d4ad960.png";